
export const imgStyleComp={
  width:'150px',
  margin:'25px auto 40px'
}


export const matCard= {
  paddingTop: {
    xs: "0.5rem",
    md:'5rem'
  },
  paddingBottom:  {
    xs: "0.5rem",
    md:'5rem'
  },
  margin: {
    xs: "0.5em 0",
    md: '2em 5em'
  }
}

export const matCardContent= {
  fontSize: {
    xs: "1rem",
    md: "1.5rem"
  },
  color: '#333b46',
  fontWeight:'500'
}


export const matCardActions={
  display: 'flex',
  justifyContent: 'space-evenly',
  marginTop:'1em'
}

export const matCardActions2={
  display: 'flex',
  justifyContent: 'center',
  marginTop:'1em'
}

export const flexBasis30={
  flexBasis: {
    xs: "none",
    md: "30%"
  },
  fontSize:'14px',
  textTransform:'none',
  fontWeight:'600'
  // color:'white'
}

export const flexBasis25={
  flex: '0 0 25%',
  fontSize:'14px',
  textTransform:'none',
  fontWeight:'600'
  // color:'white'
}

export const submitBtn={
  fontSize:'14px',
  fontWeight:'bold',
  textTransform:'none'
  // color:'white'
}

export const correctWrongBtn={
  fontSize: {
    xs: "1.5rem",
    md: '3rem'
  },
   margin: {
    xs: "0rem",
    md: '2rem'},
   textTransform:'none'
}
